import { useMemo } from 'react';
import { useGetBuyListLocations, useGetLocations } from '~/api/location';
import type { BuyListLocationsQuery } from '~/graphql/graphql';

export function useShipToLocations(): {
  locations: BuyListLocationsQuery['buyListLocations'];
  isLoading: boolean;
  error: Error | null;
} {
  const {
    data: buyListLocationsData,
    isLoading: buyListLoading,
    error: buyListError,
  } = useGetBuyListLocations();
  const {
    data: userLocationsData,
    isLoading: userLoading,
    error: userError,
  } = useGetLocations();

  const locations = useMemo(() => {
    const shippableLocationIds = new Set(
      (userLocationsData?.locations ?? []).map((location) => location.id)
    );
    return (buyListLocationsData?.buyListLocations ?? []).filter((location) =>
      shippableLocationIds.has(location.id)
    );
  }, [buyListLocationsData, userLocationsData]);

  return {
    locations,
    isLoading: buyListLoading || userLoading,
    error: buyListError ?? userError,
  };
}
